<template>
  <div class="SubscriptionConsumptionTabs" role="tablist" :data-locator="dataLocator">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      role="tab"
      :aria-selected="modelValue === tab.id"
      class="SubscriptionConsumptionTabs__tab"
      :class="{ 'SubscriptionConsumptionTabs__tab--active': modelValue === tab.id }"
      :data-locator="`${tab.id}-tab`"
      @click="$emit('update:modelValue', tab.id)"
    >
      {{ $t(tab.labelKey) }}
    </button>
  </div>
</template>

<script>
  // Shared tab bar (`v-model` = active tab id, `tabs` = `{ id, labelKey }[]`). The bottom
  // separator is left to the parent's `__tab-header` so a search field can sit beside it.
  export default {
    name: 'SubscriptionConsumptionTabs',
    props: {
      modelValue: {
        type: String,
        required: true,
      },
      tabs: {
        type: Array,
        required: true,
      },
      dataLocator: {
        type: String,
        default: undefined,
      },
    },
    emits: ['update:modelValue'],
  }
</script>

<style scoped lang="scss">
  .SubscriptionConsumptionTabs {
    display: flex;
    gap: 8px;
  }

  .SubscriptionConsumptionTabs__tab {
    position: relative;
    padding: 14px 16px;
    line-height: 20px;
    font-weight: 700;
    color: rgb(var(--v-theme-text-tertiary));

    &--active {
      color: rgb(var(--v-theme-text-primary));

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -1px;
        height: 2px;
        background-color: rgb(var(--v-theme-primary));
      }
    }
  }
</style>
